import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { createRichTextEditorInstance } from '../../../Models/RichTextEditor';
import './RichTextEditor.css';
import { toast, ToastContainer } from 'react-toastify';

const RichTextEditor = ({ id }) => {
    const editorRef = useRef(null);
    const quillRef = useRef(null);
    const richTextModelRef = useRef(null);

    useEffect(() => {
        if (editorRef.current) {
            editorRef.current.innerHTML = '';
        }
        quillRef.current = null;

        const toolbarOptions = [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'image', 'video']
        ];

        const quill = new Quill(editorRef.current, {
            modules: {
                toolbar: toolbarOptions
            },
            theme: 'snow'
        });
        
        quillRef.current = quill;

        // Initialize model
        const model = createRichTextEditorInstance();
        richTextModelRef.current = model;

        (async () => {
            try {
                const data = await model.load(id);
                if (data && data.content) {
                    quill.root.innerHTML = data.content.html || '';
                    model.setId(id);
                    model.id = id;
                }
            } catch (error) {
                console.error('Error loading editor content:', error);
            }
        })();

        return () => {
            // Cleanup: remove Quill toolbar and editor content
            if (editorRef.current) {
                editorRef.current.innerHTML = '';
            }
            quillRef.current = null;
        };
    }, [id]);

    const handleSave = async () => {
        if (!quillRef.current || !richTextModelRef.current) return;

        try {
            const html = quillRef.current.root.innerHTML;
            const delta = quillRef.current.getContents();
            
            // Save both HTML and Delta format
            richTextModelRef.current.setContent({
                html,
                delta: JSON.stringify(delta)
            });
            
            await richTextModelRef.current.save(id);
            toast.success('Content saved successfully!');
        } catch (error) {
            console.error('Error saving content:', error);
            toast.error('Error saving content');
        }
    };

    return (
        <div className="rich-text-editor-container">
            <ToastContainer />
            <div ref={editorRef} className="editor-content" />
            <div className="editor-footer">
                <button onClick={handleSave} className="save-button">
                    Save Content
                </button>
            </div>
        </div>
    );
};

export default RichTextEditor;
